import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import 'common/treeModule';
import './exhibitorsServices';
import '../modules/modulesServices';

const exhibitorsControllers = angular.module('applicationModule.exhibitorsControllers', [
    'ngSanitize',
    'applicationModule.exhibitorsServices',
    'applicationModule.modulesServices',
    'commonModule.treeModule',
    'ngFileUpload',
    'ui.bootstrap',
    'ui.select',
    'ngTable'
]);

// Exhibitors List Controller
exhibitorsControllers.controller('ExhibitorsListController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'Exhibitor', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, Exhibitor, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.writeAccess = Permissions.hasWriteAccess('exhibitors') || Permissions.hasAnyAccess('provider');
    $scope.application_id = $stateParams.application_id;
    $scope.search = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Exhibitor.getList($scope.application_id, params && params._params ? params._params : {})
                .then(function (response) {
                    $scope.categories = response.categories;
                    params.total(response.exhibitors.total);
                    params.count(response.exhibitors.per_page);
                    params.page(response.exhibitors.current_page);
                    return response.exhibitors.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeExhibitor = function (id, index) {
        Exhibitor.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.EXHIBITORS.SUCCESS.DELETE_EXHIBITOR');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.EXHIBITORS.ERROR.DELETE');
                }
            });
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.newExhibitor = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/exhibitors/components/modal/exhibitor.tpl.html',
            controller: 'ExhibitorModalController',
            resolve: {
                exhibitor: function () {
                    return {
                        superadmin: Permissions.hasSuperAdminAccess()
                    };
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.EXHIBITORS.SUCCESS.EXHIBITOR_CREATED');
        }).catch(() => {});
    };

    $scope.searchExhibitors = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.category)) {
            $scope.tableParams._params.category = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);


// Exhibitor Page Controller
exhibitorsControllers.controller('ExhibitorPageController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Exhibitor', function ($scope, $rootScope, $state, $stateParams, growl, Exhibitor) {
    'use strict';
    $scope.editMode = false;
    $scope.status = 1;
    $scope.exhibitor = {};
    $scope.formErrors = {};
    $scope.imageRequired = true;
    $scope.imageRequiredMini = true;
    $scope.upload = undefined;
    $scope.uploadMini = undefined;
    $scope.fileUploaded = false;
    $scope.fileUploadedMini = false;

    const appId = $stateParams.application_id;
    $scope.exhibitor.app_id = appId;
    $scope.exhibitor.status = 1;

    if (angular.isDefined($stateParams.exhibitorId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;

        const exhibitorId = $stateParams.exhibitorId;

        Exhibitor.get(exhibitorId, appId)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.imageRequired = false;
                    $scope.imageRequiredMini = false;
                    $scope.exhibitor = data.exhibitor[0];
                    $scope.fileUploaded = true;
                    $scope.fileUploadedMini = true;
                    if ($scope.exhibitor.status == true) {
                        $scope.exhibitor.status = 1;
                    } else {
                        $scope.exhibitor.status = 0;
                    }
                } else {
                    growl.error('MODULES.EXHIBITOR.' + data.error);
                }
            })
            .catch(function () {
                $state.go('appsoup.application.exhibitors', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.exhibitor.application_id = appId;
        $scope.isLoading = true;
        Exhibitor.save($scope.exhibitor, $scope.upload, $scope.uploadMini, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    if ($scope.editMode) {
                        growl.success('MODULES.EXHIBITORS.SUCCESS.EXHIBITOR_UPDATED');
                    } else {
                        growl.success('MODULES.EXHIBITORS.SUCCESS.EXHIBITOR_CREATED');
                    }
                    $state.go('appsoup.application.exhibitors', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        if ($scope.editMode) {
                            growl.success('MODULES.EXHIBITORS.ERROR.EXHIBITOR_UPDATED');
                        } else {
                            growl.error('MODULES.EXHIBITORS.ERROR.EXHIBITOR_CREATED');
                        }
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
                $scope.isLoadingMini = false;
            });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.exhibitors', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.EXHIBITOR_NAME'}],
        'description': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.DESCRIPTION'}],
        'category': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'photos_link': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.PHOTOS_LINK'}],
        'videos_link': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.VIDEOS_LINK'}],
        'brochure_link': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.BROSHURE_LINK'}],
        'workers': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.WORKERS'}]
    };

}]);

// Exhibitor Page Controller
exhibitorsControllers.controller('ProviderPageController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Exhibitor', function ($scope, $rootScope, $state, $stateParams, growl, Exhibitor) {
    'use strict';
    $scope.editMode = false;
    $scope.status = 1;
    $scope.exhibitor = {};
    $scope.formErrors = {};
    $scope.imageRequired = true;
    $scope.imageRequiredMini = true;
    $scope.upload = undefined;
    $scope.uploadMini = undefined;
    $scope.fileUploaded = false;
    $scope.fileUploadedMini = false;
    $rootScope.dishesTypeLabel = 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.MAIN';

    const appId = $stateParams.application_id;
    $scope.exhibitor.app_id = appId;
    $scope.exhibitor.status = 1;

    if (angular.isDefined($stateParams.exhibitorId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;

        const exhibitorId = $stateParams.exhibitorId;

        Exhibitor.get(exhibitorId, appId)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.imageRequired = false;
                    $scope.imageRequiredMini = false;
                    $scope.exhibitor = data.exhibitor[0];
                    $scope.fileUploaded = true;
                    $scope.fileUploadedMini = true;
                    if ($scope.exhibitor.status == true) {
                        $scope.exhibitor.status = 1;
                    } else {
                        $scope.exhibitor.status = 0;
                    }
                } else {
                    growl.error('MODULES.EXHIBITOR.' + data.error);
                }
            })
            .catch(function () {
                $state.go('appsoup.application.dishes', {
                    application_id: appId,
                    dishesType: 'exhibitors'
                }, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.exhibitor.application_id = appId;
        $scope.isLoading = true;
        Exhibitor.save($scope.exhibitor, $scope.upload, $scope.uploadMini, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    if ($scope.editMode) {
                        growl.success('MODULES.EXHIBITORS.SUCCESS.EXHIBITOR_UPDATED');
                    } else {
                        growl.success('MODULES.EXHIBITORS.SUCCESS.EXHIBITOR_CREATED');
                    }
                    $state.go('appsoup.application.dishes', {application_id: appId, dishesType: 'exhibitors'});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.EXHIBITORS.ERROR.EXHIBITOR_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
                $scope.isLoadingMini = false;
            });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.dishes', {application_id: appId, dishesType: 'exhibitors'});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.EXHIBITOR_NAME'}],
        'category': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'description': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.DESCRIPTION'}],
        'photos_link': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.PHOTOS_LINK'}],
        'videos_link': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.VIDEOS_LINK'}],
        'brochure_link': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.BROSHURE_LINK'}],
        'workers': [{type: '$invalid', msg: 'MODULES.EXHIBITORS.ERROR.REQUIRE.WORKERS'}]
    };

}]);

export default exhibitorsControllers;
